import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Course } from 'src/app/classes/Course';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root',
})
export class CoursesService {

  constructor(private httpClient: HttpClient) {
  }

  public getAll(page: number, size: number, filters: any = {}): Observable<any> {
    let params = new HttpParams();
    params = params.append('page', page);
    params = params.append('size', size);
    const options = {
      ...httpOptions,
      params,
    };
    return this.httpClient.post<any>(`${environment.backendApiUrl}/v1/lessons-bundle/list`, { ...filters }, options);
  }

  public addOrEdit(course: Partial<Course>, courseId?: number): Observable<any> {
    if (courseId) {
      return this.httpClient
        .put<void>(`${environment.backendApiUrl}/v1/lessons-bundle/` + courseId, course, httpOptions);
    }
    return this.httpClient.post<void>(`${environment.backendApiUrl}/v1/lessons-bundle`, course, httpOptions);
  }

  public delete(id: number): Observable<void> {
    return this.httpClient.delete<void>(`${environment.backendApiUrl}/v1/lessons-bundle/` + id, httpOptions);
  }
}
